export const TOOL_LIST = [
  // Exa AI Tools
  {
    provider: 'exa',
    name: 'Exa Web Search',
    value: 'exa_web_search',
    description:
      'Search the web using Exa AI - performs real-time web searches and can scrape content from specific URLs. Supports configurable result counts and returns the content from the most relevant websites',
  },
  {
    provider: 'exa',
    name: 'Exa Research Paper Search',
    value: 'exa_research_paper_search',
    description:
      'Search across 100M+ research papers with full text access using Exa AI - performs targeted academic paper searches with deep research content coverage. Returns detailed information about relevant academic papers including titles, authors, publication dates, and full text excerpts.',
  },
  {
    provider: 'exa',
    name: 'Exa Twitter Search',
    value: 'exa_twitter_search',
    description:
      'Search Twitter/X.com posts and accounts using Exa AI - performs targeted searches of Twitter (X.com) content including tweets, profiles, and discussions. Returns relevant tweets, profile information, and conversation threads based on your query.',
  },
  {
    provider: 'exa',
    name: 'Exa LinkedIn Search',
    value: 'exa_linkedin_search',
    description:
      'Search LinkedIn for companies using Exa AI - simply include company URL, or company name, with "company page" appended in your query.',
  },
  {
    provider: 'exa',
    name: 'Exa Company Research',
    value: 'exa_company_research',
    description:
      'Research companies using Exa AI - performs targeted searches of company websites to gather comprehensive information about businesses. Returns detailed information from company websites including about pages, pricing, FAQs, blogs, and other relevant content.',
  },

  // Firecrawl Tools
  {
    provider: 'firecrawl',
    name: 'Firecrawl Scrape',
    value: 'firecrawl_scrape',
    description:
      'Scrape a single webpage with advanced options for content extraction. Supports various formats including markdown, HTML, and screenshots. Can execute custom actions like clicking or scrolling before scraping.',
  },
  {
    provider: 'firecrawl',
    name: 'Firecrawl Crawl',
    value: 'firecrawl_crawl',
    description:
      'Start an asynchronous crawl of multiple pages from a starting URL. Supports depth control, path filtering, and webhook notifications.',
  },
  {
    provider: 'firecrawl',
    name: 'Firecrawl Extract',
    value: 'firecrawl_extract',
    description:
      'Extract structured information from web pages using LLM. Supports both cloud AI and self-hosted LLM extraction.',
  },

  // Perplexity Tools
  {
    provider: 'perplexity',
    name: 'Perplexity Ask',
    value: 'perplexity_ask',
    description:
      'Engages in a conversation using the Perplexity API. Accepts an array of messages (each with a role and content) and returns a ask completion response from the Perplexity model.',
  },
  {
    provider: 'perplexity',
    name: 'Perplexity Research',
    value: 'perplexity_research',
    description:
      'Performs deep research using the Perplexity API. Accepts an array of messages (each with a role and content) and returns a comprehensive research response with citations.',
  },
  {
    provider: 'perplexity',
    name: 'Perplexity Reason',
    value: 'perplexity_reason',
    description:
      'Performs reasoning tasks using the Perplexity API. Accepts an array of messages (each with a role and content) and returns a well-reasoned response using the sonar-reasoning-pro model.',
  },

  // Tavily Tools
  {
    provider: 'tavily',
    name: 'Tavily Web Search',
    value: 'tavily_web_search',
    description:
      "A powerful web search tool that provides comprehensive, real-time results using Tavily's AI search engine. Returns relevant web content with customizable parameters for result count, content type, and domain filtering.",
  },
  {
    provider: 'tavily',
    name: 'Tavily Reddit Search',
    value: 'tavily_reddit_search',
    description:
      "A powerful reddit search tool that provides general search results from Reddit using Tavily's AI search engine.",
  },

  // Jina Tools
  {
    provider: 'jina',
    name: 'Jina SERP Search',
    value: 'jina_serp_search',
    description:
      'Use s.jina.ai to search the web and get SERP - performs searches using the Jina Search API endpoint. Returns search results based on the provided query and configuration options.',
  },

  // Mem0 Tools
  {
    provider: 'mem0',
    name: 'Mem0 Memory Manager',
    value: 'mem0_memory_manager',
    description:
      'Manage personal memories with add memories(Store new memory objects), search memories(Retrieve relevant memories) and list memories(View all stored memories) operations.',
  },

  // SEO Tools
  {
    provider: 'supaflow',
    name: 'SEO Hook Generator',
    value: 'seo_hook_generator',
    description:
      "Add an irresistible hook to your writing and grab any reader's attention with this powerful tool.",
  },

  // Blog Tools
  {
    provider: 'supaflow',
    name: 'Blog Headline Generator',
    value: 'blog_headline_generator',
    description:
      'Generate engaging, SEO-friendly blog post headlines/titles to inspire a wide range of traffic-driving content.',
  },
  {
    provider: 'supaflow',
    name: 'Blog Conclusion Generator',
    value: 'blog_conclusion_generator',
    description:
      'Instantly craft compelling conclusions with this user-friendly tool. Elevate your writing effortlessly.',
  },
  {
    provider: 'supaflow',
    name: 'Blog Idea Generator',
    value: 'blog_idea_generator',
    description:
      'Brainstorm variations of ready-to-use, SEO-friendly blog post ideas to drive more traffic to your blog.',
  },
  {
    provider: 'supaflow',
    name: 'Blog Meta Generator',
    value: 'blog_meta_generator',
    description:
      'Craft informative, SEO-friendly meta descriptions for your articles quickly and easily.',
  },
  {
    provider: 'supaflow',
    name: 'Blog Outline Generator',
    value: 'blog_outline_generator',
    description:
      'Generates detailed SEO-optimized content outlines with structured markdown including introduction, H1/H2 headings, and bullet points. Adheres to SEO best practices for keyword use and user intent to enhance search engine ranking.',
  },
  {
    provider: 'supaflow',
    name: 'Blog Draft Generator',
    value: 'blog_draft_generator',
    description: 'Help outline and draft engaging blog posts and articles.',
  },

  // SEO Data Tools
  {
    provider: 'supaflow',
    name: 'Backlink Analysis',
    value: 'backlink_analysis',
    description:
      'Analyze backlinks for a website or URL to understand its authority and potential for traffic.',
  },
  {
    provider: 'supaflow',
    name: 'Traffic Analysis',
    value: 'traffic_analysis',
    description:
      'Analyze traffic data for a website or URL to understand its traffic sources and potential for traffic.',
  },
  {
    provider: 'supaflow',
    name: 'Keyword Difficulty',
    value: 'keyword_difficulty',
    description:
      'Analyze keyword difficulty for a website or URL to understand its difficulty in ranking for specific keywords.',
  },
  {
    provider: 'supaflow',
    name: 'Keyword Generator',
    value: 'keyword_generator',
    description:
      'Generate keywords for a website or URL to understand its potential for traffic.',
  },
];

export const TOOL_LIST_BY_PROVIDER = {
  'Exa AI Tools': TOOL_LIST.filter((tool) => tool.provider === 'exa'),
  'Firecrawl Tools': TOOL_LIST.filter((tool) => tool.provider === 'firecrawl'),
  'Perplexity Tools': TOOL_LIST.filter(
    (tool) => tool.provider === 'perplexity'
  ),
  'Tavily Tools': TOOL_LIST.filter((tool) => tool.provider === 'tavily'),
  'Jina Tools': TOOL_LIST.filter((tool) => tool.provider === 'jina'),
  'Mem0 Tools': TOOL_LIST.filter((tool) => tool.provider === 'mem0'),
  'SEO Tools': TOOL_LIST.filter((tool) => tool.provider === 'supaflow'),
};
